import { Fragment } from "react";
import { useSnackbar } from "notistack";
import { useIntl } from "react-intl";

import { StaticInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { useUser } from "@dzambalaorg/provider-user";
import { FormWrapper } from "@dzambalaorg/mui-form";
import { AvatarInput } from "@dzambalaorg/mui-inputs-image-firebase";
import type { IMerchant, IUser } from "@framework/types";
import { PageHeader } from "@dzambalaorg/mui-page-layout";
import { useMutationQuery } from "@dzambalaorg/react-hooks";
import { FormGrid } from "@dzambalaorg/ui-kit";

import { ITabPanelProps } from "../tabs";
import { validationSchema } from "./validation";
import { SocialInput } from "./social-input";

export const MerchantGeneral = (props: ITabPanelProps) => {
  const { open } = props;

  const { enqueueSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();

  const { mutateAsync } = useMutationQuery("/merchants", "PUT", void 0, {
    onSuccess: () => {
      enqueueSnackbar(formatMessage({ id: "snackbar.updated" }), { variant: "success" });
      void user.getProfile();
    },
  });
  const user = useUser<IUser>();

  const handleSubmit = async (values: Partial<IMerchant>) => {
    const { id: _id, ratePlan: _ratePlan, ...data } = values;
    await mutateAsync({ data });
  };

  const { id, title, description, email, wallet, imageUrl, social, ratePlan } = user.profile.merchant;
  const fixedValues = { id, title, description, email, wallet, imageUrl, social, ratePlan };

  if (!open) {
    return null;
  }

  return (
    <Fragment>
      <PageHeader message="pages.merchant.tabs.general" />

      <FormWrapper
        showPrompt={false}
        initialValues={fixedValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <FormGrid columns={[3, 2, 2, 1, 1]}>
          <AvatarInput name="imageUrl" />
          <FormGrid.Empty />
          <FormGrid.Empty />

          <TextInput name="title" />
          <StaticInput name="ratePlan" />
          <TextInput name="email" autoComplete="username" />
          <TextInput name="wallet" />
          <RichTextEditor name="description" />
          <SocialInput name="social" />
        </FormGrid>
      </FormWrapper>
    </Fragment>
  );
};
